import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
export default Vue.extend({
    data() {
        return {
            wishlistLoading: false,
            isFavorite: false,
        };
    },
    props: {},
    computed: {
        ...mapState('authModule', ['isLoggedIn']),
        ...mapState('wishlistModule', ['allItems', 'itemsWishlist']),
        ...mapGetters('wishlistModule', ['isOnWishlist']),
        ...mapState('productModule', ['currentProduct']),
    },
    methods: {
        ...mapActions('wishlistModule', ['addToWishList', 'removeWishlistItem']),
        async toggleWishlist() {
            if (this.wishlistLoading)
                return;
            this.wishlistLoading = true;
            const started = Date.now();
            const MIN_VISIBLE_MS = 400;
            await this.$nextTick();
            await new Promise(r => requestAnimationFrame(() => r()));
            try {
                let maybe;
                if (!this.isOnWishlist(this.currentProduct.uuid)) {
                    const item = { productUuid: this.currentProduct.uuid };
                    maybe = this.addToWishList(item);
                }
                else {
                    const wishlistUuid = this.getWishlistUuidByProductUuid(this.currentProduct.uuid);
                    if (wishlistUuid) {
                        const item = { wishlistUuid };
                        maybe = this.removeWishlistItem(item);
                    }
                }
                if (maybe && typeof maybe.then === 'function') {
                    await maybe;
                }
                else {
                    await new Promise(r => setTimeout(r, 300));
                }
            }
            catch (e) {
                console.error('Wishlist toggle failed:', e);
            }
            finally {
                const elapsed = Date.now() - started;
                const waitMore = Math.max(0, MIN_VISIBLE_MS - elapsed);
                if (waitMore > 0)
                    await new Promise(r => setTimeout(r, waitMore));
                this.wishlistLoading = false;
            }
        },
        addProductToWishlist() {
            if (!this.isOnWishlist(this.currentProduct.uuid)) {
                this.toggleIsFavorite();
                const item = { productUuid: this.currentProduct.uuid };
                this.addToWishList(item);
            }
        },
        removeProductToWishlist() {
            if (this.isOnWishlist(this.currentProduct.uuid)) {
                let item = { wishlistUuid: this.getWishlistUuidByProductUuid(this.currentProduct.uuid) };
                this.removeWishlistItem(item);
            }
            else {
                return null;
            }
        },
        getWishlistUuidByProductUuid(productUuid) {
            const match = this.itemsWishlist.find(item => item?.product?.uuid === productUuid);
            return match ? match.wishlistUuid : null;
        },
        toggleIsFavorite() {
            this.isFavorite = !this.isFavorite;
        },
    },
});
